import { TaskerMyMessages } from "@/components/tasker";

export const MyTaskerMessagesPage = TaskerMyMessages;
